module.exports = __webpack_public_path__ + "img/dummy_image.54fe5bf7.png";